export const SEARCH_RESULTS = 'searchResults';
